// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Card, Flex, Stack, Title } from '@mantine/core';

export type BendDataCardProps = {
  /** The title text displayed at the top of the card. No title is rendered if this is not provided. */
  title?: ReactNode;
  /** An optional element displayed beside the title. */
  rightSection?: ReactNode;
  /** The content area of the card. */
  children: ReactNode;
};

/**
 * Renders a card component with a title, optional right section, and content area.
 * Used primarily to display bend-related data.
 */
export const BendDataCard = ({ title, rightSection, children }: BendDataCardProps) => (
  <Stack gap="xs">
    <Flex justify="space-between" align="center">
      {!!title && <Title order={5}>{title}</Title>}
      {rightSection}
    </Flex>
    <Card withBorder flex="0 0 auto">
      {children}
    </Card>
  </Stack>
);
